export default __webpack_public_path__ + "static/media/boster.90f772c4.svg";